'use client';
import * as React from 'react';
import { createContext, useContext, useMemo, useState } from 'react';
import { StorageService } from '../services';

export interface AccessTokenContextType {
  accessToken: string;
  setAccessToken(f: string | ((prev: string) => string)): void;
}

const AccessTokenContext = createContext<AccessTokenContextType>({} as AccessTokenContextType);

export const useAccessToken = () => {
  return useContext(AccessTokenContext);
};

export const AccessTokenProvider = ({ children }: { children: React.ReactNode }) => {
  const [accessToken, setAccessToken] = useState<string>();

  React.useEffect(() => {
    const token = StorageService.accessToken.getValue() as string;

    if (token) {
      setAccessToken(token);
    }
  }, []);

  const values = useMemo<AccessTokenContextType>(() => {
    return {
      accessToken,
      setAccessToken
    } as AccessTokenContextType;
  }, [accessToken, setAccessToken]);

  return <AccessTokenContext.Provider value={values}>{children}</AccessTokenContext.Provider>;
};
